export type ResourceResult<TValue, TError> =
  | { readonly _tag: 'Ok'; readonly value: TValue }
  | { readonly _tag: 'Err'; readonly error: TError }

export const resourceOk = <TValue>(
  value: TValue,
): ResourceResult<TValue, never> => ({ _tag: 'Ok', value })

export const resourceErr = <TError>(
  error: TError,
): ResourceResult<never, TError> => ({ _tag: 'Err', error })
